// @core/api/endpoints/task/create_task_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTaskCategoryRequest,
  TaskCategoryResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create task category
 * Creates a hierarchical task category for organizing tasks.
 */
export async function CreateTaskCategory(
  data: CreateTaskCategoryRequest,
  options?: RequestOptions
): Promise<TaskCategoryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-categories`;
  const requestOptions = options;
  return client.post<TaskCategoryResponse>(requestPath, data, requestOptions);
}
